<template>
  <div class="map-box">
    <!-- <div class="map" ref="map">
      <div class="pop-detail"
           ref="pop"
           v-if="current"
           :style="{'left': pos.left+'px', 'top': pos.top+'px'}" >
        <dl>
          <dt>
            {{current.name}}
          </dt>
          <dd>
            <em class="p-icons p-i-add"></em>
            {{current.address}}
          </dd>
          <dd>
            <em class="p-icons p-i-phone"></em>
            {{current.phone}}
          </dd>
        </dl>
      </div>

      <div v-for="(item, key) in centrals"
           :key="key"
           :id="key"
           class="distric"
           @mouseenter="showDetail"
           @mouseout="hideDetail"
           :class="key">
        <div class="txt-place" :class="key">
          <em class="p-icon" :class="{'main': item.isMain, 'comp': !item.isMain}"></em>
          <em class="p-icon yf"></em>
          {{item.city}}
        </div>
      </div>
    </div> -->
    <div class="Legend clearfix">
      <div class="legend-column add-host" style="width: 120px;">
        <h6>总部</h6>
        <a href="javascript:void(0);" class="beij">北京</a>
      </div>
      <div class="legend-column item-mg add-org" style="min-width: 16em;">
        <h6>研发中心</h6>
        <ul>
          <li>
            <div class="org-item">
              <label for="">北京</label>
              <div>人工智能研究院</div>
              <div class="intelligent">智慧医保研究院</div>
              <div class="org-concat">010-62680078</div>
            </div>
          </li>
          <li>
            <div class="org-item">
              <label for="">西安</label>
              <div class="intelligent">软件研发中心</div>
              <div class="org-concat">029-3654789</div>
            </div>
          </li>
          <li>
            <div class="org-item">
              <label for="">广州</label>
              <div class="intelligent">智能硬件研发中心</div>
              <div class="org-concat">020-83041965</div>
            </div>
          </li>
        </ul>
      </div>
      <div class="legend-column add-branch" style="min-width: 19.5em;">
        <h6>分支机构</h6>
        <ul>
          <li>
            <a href="javascript:void(0);">广州</a>
            <a href="javascript:void(0);">重庆</a>
            <a href="javascript:void(0);">南京</a>
            <a href="javascript:void(0);">西安</a>
             <a href="javascript:void(0);">郑州</a>
             <a href="javascript:void(0);">兰州</a>
            <a href="javascript:void(0);">呼和浩特</a>
            <a href="javascript:void(0);">哈尔滨</a>
            <a href="javascript:void(0);">长春</a> 
            <a href="javascript:void(0);">石家庄</a> 
            <a href="javascript:void(0);">武汉</a> 
          </li>
        </ul>
      </div>
      <div class="legend-column coverage add-business" style="min-width: 19.5em;">
        <h6>业务分布</h6>
        <ul>
          <li>
            <a href="javascript:void(0);">北京</a>
            <a href="javascript:void(0);">河北</a>
            <a href="javascript:void(0);">河南</a>
            <a href="javascript:void(0);">陕西</a>
            <a href="javascript:void(0);">江苏</a>

            <a href="javascript:void(0);">湖南</a>
            <a href="javascript:void(0);">湖北</a>
            <a href="javascript:void(0);">四川</a>
            <a href="javascript:void(0);">云南</a>
            <a href="javascript:void(0);">贵州</a>

            <a href="javascript:void(0);">广东</a>
            <a href="javascript:void(0);">重庆</a>
            <a href="javascript:void(0);">山东</a>
            <a href="javascript:void(0);">农垦</a>
            <a href="javascript:void(0);">黑龙江</a>

            <a href="javascript:void(0);">吉林</a>
            <a href="javascript:void(0);">辽宁</a>
            <a href="javascript:void(0);">浙江</a>
            <a href="javascript:void(0);">江西</a>
            <a href="javascript:void(0);">安徽</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        centrals: {
          bj: {
            name: '北京研发中心',
            address: '北京市海淀区知春路9号坤讯大厦5F',
            phone: '010-62680078',
            city: '北京',
            isMain: true
          },
          xa: {
            name: '西安研发中心',
            address: '陕西省西安市西安国际企业中心B座1709',
            phone: '029-3654789',
            city: '西安'
          },
          gz: {
            name: '广州研发中心',
            address: '广州市越秀区豪贤路102号汇德大厦1603（粤财大厦对面）',
            phone: '020-83041965',
            city: '广州'
          },
          heb: {
            city: '哈尔滨'
          },
          cc: {
            city: '长春'
          },
          zz: {
            city: '郑州'
          },
          cd: {
            city: '成都'
          },
          cq: {
            city: '重庆'
          },
          cs: {
            city: '长沙'
          },
          km: {
            city: '昆明'
          }
        },
        current: '',
        pos: {
          left: 0,
          top: 0
        }
      };
    },
    methods: {
      showDetail (e) {
        var target = e.target,
            id = target.getAttribute('id'),
            current = target.getBoundingClientRect(),
            cPos = this.$refs.map.getBoundingClientRect(),
            pop,
            self = this;

        this.current = this.centrals[id];
        setTimeout(function () {
          pop = self.$refs.pop.getBoundingClientRect()
          self.pos.left = current.left - cPos.left - pop.width - 10;
          self.pos.top = current.top - pop.height - 80;
        }, 1);
      },
      hideDetail () {
        this.current = null;
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .map-box {
    width: 1000px;
    margin: 25px auto 0;
    display: flex;
    .map {
      width: 570px;
      height: 469px;
      margin-top: 40px;
      background: url('../assets/images/map.png') no-repeat left top;
      -webkit-background-size: contain;
      background-size: contain;
      position: relative;
    }
    .Legend {
      display: flex;
      flex-wrap: wrap;
      // margin-left: 110px;
      .legend-column {
        flex: 1;
        // width: 25%;
        padding-right: 20px;
        &:nth-child(2) {
          h6 {
            background-image: url('../assets/images/branch-icon.png');
          }
        }
        &:nth-child(3) {
          h6 {
            background-image: url('../assets/images/center-icon.png');
          }
        }
        &.coverage {
          position: relative;
          h6 {
            background: none;
            &:before {
              content: '';
              display: inline-block;
              width: 16px;
              height: 16px;
              background-color: #acdffa;
              position: absolute;
              top: 19px;
              left: 2px;
            }
          }
        }
      }

      .org-concat {
        &:before {
          content: '';
          float: left;
          width: 0.8em;
          height: 1em;
          background: url('../assets/images/icon-contact-dark.png') no-repeat center center;
          // outline: 1px solid #f00;
          background-size: contain;
          position: relative;
          top: 5px;
          margin-right: 6px;
        }
      }
      .org-item {
        &:after {
          content: ' ';
          display: table;
          clear: both
        }
        padding-left: 3em;
        label {
          float: left;
          width: 3em;
          margin-left: -3em;
        }
      }
      h6 {
        font-weight: 800;
        line-height: 56px;
        font-size: 16px;
        padding-left: 30px;
        background: url('../assets/images/beij-icon.png') no-repeat left center;
        -webkit-background-size: 1.2em;
        background-size: 1.2em;
      }
      ul, .beij {
        padding-left: 30px;
      }
      a {
        cursor: default;
        margin-right: 16px;
        color: inherit;
        font-size: inherit;
        white-space: nowrap;
        word-break: keep-all;
        span {
          font-size: 14px;
          margin-left: 10px;
        }
        .intelligent {
          font-size: inherit;
          display: inline-block;
          padding-left: 32px;
        }
      }
      li {
        line-height: 1.5em;
      }
      .item-mg {
        li:not(:first-child) {
          margin-top: 25px;
        }
      }
    }
    .pop-detail {
      background: rgba(0, 0, 0, .55);
      border-radius: 4px;
      overflow: hidden;
      color: #fdfdfd;
      font-size: 14px;
      padding: 15px;
      width: 245px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 100;
      dt {
        font-size: 16px;
        color: #00ccff;
        font-weight: bold;
        line-height: 2em;
      }
      dd {
        line-height: 1.5em;
        margin-top: 8px;
        padding-left: 20px;
      }
      .p-icons {
        display: inline-block;
        width: 10px;
        height: 20px;
        float: left;
        margin-left: -20px;
        background-repeat: no-repeat;
        background-position: center center;
        position: relative;
        top: 1px;
        &.p-i-add {
          background-image: url('../assets/images/i-pop-add.png');
        }
        &.p-i-phone {
          background-image: url('../assets/images/i-pop-phone.png');
        }
      }
    }

    .txt-place {
      position: absolute;
      z-index: 10;
      left: 0;
      top: 0;
      font-size: 14px;
      font-weight: bold;
      color: #2a2a2a;
      width: 60px;
      padding-left: 18px;
      pointer-events: none;
      &.bj {
        left: 5px;
        top: -12px;
        .main {
          left: -6px;
          top: 5px;
          z-index: 5;
        }
      }
      &.xa {
        left: 22px;
        top: 57px;
        .yf {
          position: absolute;
          left: -6px;
          top: 5px;
          z-index: 5;
        }
      }
      &.gz {
        left: 30px;
        top: 8px;
        .comp {
          left: -6px;
          top: 0;
          z-index: 1;
        }
        .yf{
          z-index: 6;
          top: 6px;
        }
      }
      &.heb{
        left: 485px;
        top: 68px;
        .yf{
          display: none;
        }
      }
      &.cc{
        top: 102px;
        left: 483px;
        .yf{
          display: none;
        }
      }
      &.zz{
        top: 242px;
        left: 390px;
        .yf{
          display: none;
        }
      }
      &.cs{
        top: 322px;
        left: 380px;
        .yf{
          display: none;
        }
      }
      &.cq{
        top: 306px;
        left: 320px;
        .yf{
          display: none;
        }
      }
      &.cd{
        top: 285px;
        left: 292px;
        .yf{
          display: none;
        }
      }
      &.km{
        top: 366px;
        left: 262px;
        .yf{
          display: none;
        }
      }

      .p-icon {
        display: inline-block;
        width: 15px;
        height: 20px;
        background-repeat: no-repeat;
        background-position: center center;
        position: absolute;
        left: 0;
        top: 0;
        &.comp {
          background-image: url('../assets/images/district/d-comp.png');
        }
        &.main {
          background-image: url('../assets/images/district/d-main.png');
        }
        &.yf {
          background-image: url('../assets/images/district/d-yf.png');
        }
      }
    }
    .distric {
      position: absolute;
      z-index: 10;
      left: 0;
      top: 0;
      background-repeat: no-repeat;
      -webkit-background-size: contain;
      background-size: contain;
      cursor: pointer;
      &:hover {
        opacity: 1;
        &.bj {
          background-image: url('../assets/images/district/beijing.png');
        }
        &.xa {
          background-image: url('../assets/images/district/xian.png');
        }
        &.gz {
          background-image: url('../assets/images/district/guanghzou.png');
        }
      }
      &.bj {
        left: 414px;
        top: 167px;
        width: 16px;
        height: 16px;
      }
      &.xa {
        width: 56px;
        height: 101px;
        left: 316px;
        top: 189px;
      }
      &.gz {
        width: 88px;
        height: 70px;
        left: 366px;
        top: 368px;
      }
    }
  }
  .mobile{
    .map-box {
      padding-bottom: .80rem!important;
      width: 100%;
      @include c_wrap();

      .Legend {
        display: block;
        * {
          font-size: 0.25rem;
        }
        a {
          margin-bottom: 0.08rem;
          display: inline-block;
        }
        h6 {
        padding-left: 0.4rem;
        }
      }
      .org-item div {
        margin-bottom: 0.1rem;
      }
      .legend-column {
        margin-bottom: 0.2rem;
      }
      // .map{
      //   background: url('../assets/images/map-m.png') no-repeat center top;
      //   width: 100%;
      //   height: 5.80rem;
      //   padding-bottom: .50rem;
      //   -webkit-background-size: contain;
      //   background-size: contain;
      // }
    }
    .txt-place{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue